module.exports = __webpack_public_path__ + "static/media/table-section-icon.744f2307.svg";